<!--
 * @Author: 仙道
 * @Date: 2022-08-13 00:17:18
 * @LastEditTime: 2022-08-15 22:15:09
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/equipment/defect/vue/DefRegisterListForDetail.vue
-->
<template>
  <a-card :bordered="false">
    <!-- table区域-begin -->
    <div>
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="defType" slot-scope="defType, record">
          <span v-if="record.defType==1">
            <a-tag>设备类</a-tag>
          </span>
          <span v-else-if="record.defType==2">
            <a-tag>非设备类</a-tag>
          </span>
        </span>
        <template slot="devName" slot-scope="text,record">
          <link-to-detail :id="record.devId" :text="text" pageType="drawer" route-name="FusionDevice"></link-to-detail>
        </template>
        <span slot="defLevel" slot-scope="priority, record">
          <span v-if="record.defLevel==2">
            <a-tag color="#faad14">严重</a-tag>
          </span>
          <span v-else-if="record.defLevel==3">
            <a-tag color="#ff4d4f">危急</a-tag>
          </span>
          <span v-else>
            <a-tag color="#52c41a">一般</a-tag>
          </span>
        </span>
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
        </span>
      </a-table>
    </div>
    <def-register-modal @ok="modalFormOk" ref="modalForm"></def-register-modal>
    <evnt-process-info-modal @ok="modalFormOk" ref="evntForm"></evnt-process-info-modal>
    <def-handle-list ref="defHandleList"></def-handle-list>
  </a-card>
</template>

<script>
  import { httpAction, getAction, putAction, postAction } from '@/api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DefRegisterModal from './modules/DefRegisterModal'
  import EvntProcessInfoModal from './modules/EvntProcessInfoModal'
  import { getUserList } from '@/api/api'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import DefHandleList from './DefHandleList'

  export default {
    name: 'DefRegisterList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DefRegisterModal,
      EvntProcessInfoModal,
      DefHandleList
    },
    props: {
      query: {
        type: Object,
        default: () => { }
      }
    },
    data () {
      return {
        timeRange: [],
        devClassList: [],
        UserOptions: [],
        description: '缺陷登记管理页面',
        dateFormat: "YYYY-MM-DD",
        // 表头
        columns: [
          {
            title: '缺陷类型',
            align: "center",
            dataIndex: 'defType',
            scopedSlots: { customRender: 'defType' },
          },
          {
            title: '设备名称',
            align: "center",
            dataIndex: 'devName',
            scopedSlots: { customRender: 'devName' },

          },
          {
            title: '设备类型',
            align: "center",
            dataIndex: 'devClassId_dictText'
          },
          {
            title: '缺陷部位',
            align: "center",
            dataIndex: 'defPart'
          },
          {
            title: '缺陷类别',
            align: "center",
            dataIndex: 'defCategory'
          },
          {
            title: '缺陷等级',
            align: "center",
            dataIndex: 'defLevel',
            scopedSlots: { customRender: 'defLevel' },
          },
          {
            title: '缺陷内容',
            align: "center",
            dataIndex: 'defContent'
          },
          {
            title: '缺陷发现人',
            align: "center",
            dataIndex: 'defInventor_dictText'
          },
          {
            title: '缺陷处理人',
            align: "center",
            dataIndex: 'defHandle_dictText'
          },
          {
            title: '缺陷发现时间',
            align: "center",
            dataIndex: 'defFindTime',
            width: 180,
          },
          {
            title: '当前状态',
            align: "center",
            dataIndex: 'defStatus_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 250,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/device/defRegister/list",
          delete: "/device/defRegister/delete",
          deleteBatch: "/device/defRegister/deleteBatch",
          exportXlsUrl: "/device/defRegister/exportXls",
          importExcelUrl: "org.jeecg.modules.device/defRegister/importExcel",
          selectClass: '/device/devClass/selectDropList',
          putById: "/device/defRegister/edit",
          publishUrl: "/device/defRegister/publish",
          hangUpUrl: "/device/defRegister/hangUp",
        },
        dictOptions: {},
        superFieldList: [],
        queryParam: {},
        disableMixinCreated: true,
      }
    },
    created () {
      this.getSuperFieldList()

      this.queryParam = { ...this.query }
      if (this.queryParam.manuId) {
        this.url.list = '/device/defRegister/getListByManuId'
      }
      this.loadData()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      getList () {
        if (validatenull(this.timeRange)) {
          this.queryParam.startTime = ''
          this.queryParam.endTime = ''
        } else {
          this.queryParam.startTime = this.timeRange[0]
          this.queryParam.endTime = this.timeRange[1]
        }
        this.searchQuery()
      },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'defType', text: '缺陷类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devId', text: '设备id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devName', text: '设备名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defStandardId', text: '缺陷标准id', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defStandardName', text: '缺陷标准名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defLevel', text: '缺陷等级', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defContent', text: '缺陷内容', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defPicture', text: '缺陷图片', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defInventor', text: '缺陷发现人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'defTelephone', text: '联系电话', dictCode: '' })
        fieldList.push({ type: 'string', value: 'startTime', text: '缺陷发现开始时间', dictCode: '' })
        fieldList.push({ type: 'string', value: 'endTime', text: '缺陷发现结束时间', dictCode: '' })
        fieldList.push({ type: 'int', value: 'defStatus', text: '当前状态', dictCode: 'def_status' })
        fieldList.push({ type: 'string', value: 'tenantId', text: '租户id', dictCode: '' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态', dictCode: '' })
        this.superFieldList = fieldList
      },
      getClassList () {
        getAction(this.url.selectClass, {}).then(res => {
          this.devClassList = res.result.records.map(item => {
            return {
              value: item.id,
              label: item.typeName
            }
          })
        })
      },
      remoteUserList (query) {
        let params = {
          username: query,
          // realname: query,
          // phone: query,
          // workNo: query
        }
        let sqp = {}
        // sqp['superQueryParams'] = encodeURI(params)
        // sqp['superQueryMatchType'] = 'or'
        getUserList(Object.assign(sqp, { pageSize: 999999 })).then(res => {
          this.UserOptions = res.result.records;
        })
      },
      filterOption (input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      handlePublish (row) {
        if (row.defStatus != 0 && row.defStatus != 4) {
          this.$message.error('该状态不允许发布,请确认状态是否合法.')
        }
        //发布
        postAction(this.url.publishUrl, row).then(res => {
          if (res.success) {
            this.$message.success('缺陷发布成功.')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      handleHangUp (row) {
        if (row.defStatus != 1 && row.defStatus != 2 && row.defStatus != 3) {
          this.$message.error('该状态不允许挂起,请确认状态是否合法.')
        }
        //挂起
        postAction(this.url.hangUpUrl, row).then(res => {
          if (res.success) {
            this.$message.success('缺陷挂起成功.')
            this.getList()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      //处理缺陷登记
      handleDefStandard: function (record) {
        this.$refs.evntForm.edit(record)
        this.$refs.evntForm.title = '缺陷处理'
        this.$refs.evntForm.disableSubmit = false
      },
      //查询消缺记录
      handleEvntCirculationHistory: function (record) {
        this.$refs.defHandleList.init(record.id)
      },
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>